import { render, staticRenderFns } from "./mg-table-column.vue?vue&type=template&id=95bedbfc"
import script from "./mg-table-column.vue?vue&type=script&lang=js"
export * from "./mg-table-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports